import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

import { scriptjsWrapper as getScriptJs } from 'ha/helpers/scriptjsWrapper';
import { useIntl } from 'ha/i18n';
import { ListingKind } from '@ha/api/v2/types/Listing';
import { ListingTypeTranslations } from 'ha/models/Listing/translations';
import MapPin from 'ha/img-src/svg-icons/map-pin.svg';

import { useConfig } from 'ha/helpers/config';
import {
  getCoordinates,
  getStreet,
  getCityLocalized,
  getType,
  getKind,
  getFacilities,
} from '../selectors';

declare global {
  let AvuxiHouseOnDemandWidget: any;
}

const useStyles = makeStyles()(theme => ({
  widget: {
    backgroundColor: theme.palette.grey['200'],
    marginTop: theme.spacing(6),
    height: `calc(100% - ${theme.spacing(6)})`,
    display: 'grid',
  },
}));

export const GalleryMapTopPlace = () => {
  const { T, locale } = useIntl();
  const { classes } = useStyles();
  const coordinates = useSelector(getCoordinates);
  const street = useSelector(getStreet);
  const city = useSelector(getCityLocalized);
  const type = useSelector(getType);
  const kind = useSelector(getKind);
  const facilities = useSelector(getFacilities);
  const { avuxi } = useConfig();

  let listingType: string;

  if (kind === ListingKind.EntirePlace && facilities.bedroom_count === '0') {
    listingType = T('Studio');
  } else if (kind === ListingKind.EntirePlace) {
    listingType = T(ListingTypeTranslations[type]);
  } else {
    listingType = T('Room');
  }

  React.useEffect(() => {
    getScriptJs(
      'https://scripts.avuxi.com/real-estate/house-on-demand/latest/avuxi-hod-widget-m.js',
    ).then(() => {
      // eslint-disable-next-line no-new
      new AvuxiHouseOnDemandWidget('vxapp');
    });
  }, []);

  return (
    <div
      className={classes.widget}
      id="vxapp"
      data-location={`${coordinates.lat}, ${coordinates.lng}`}
      data-headline={street}
      data-description={T('%(type)s for rent in %(place)s', {
        type: listingType,
        place: city,
      })}
      data-zoom="15"
      data-icon={MapPin}
      data-icon-size="48"
      data-language={locale}
      data-list-on-map="true"
      data-streetview="true"
      data-avuxi-key={avuxi.key}
    />
  );
};
